export class StringifyingMap {
    constructor(catToString) {
        this.catToString = catToString;
        this.internalMap = new Map();
    }
    set(k, v) {
        return this.internalMap.set(this.catToString(k), v);
    }
    get(k) {
        return this.internalMap.get(this.catToString(k));
    }
    has(k) {
        return this.internalMap.has(this.catToString(k));
    }
    delete(k) {
        return this.internalMap.delete(this.catToString(k));
    }
    get size() {
        return this.internalMap.size;
    }
    forEach(callback, thisArg) {
        this.internalMap.forEach(callback, thisArg);
    }
}
